/**
 *
 * PDF Download
 *
 * UI that handles the functionality of downloading PDF composed of one or more elements
 */

const $     = require( 'jquery' );

var PDFDownload= function(el){
  
  window.print();

};

$(document).ready(function(){
  $('.js-itbl-pdf_download').click(function(e) {
    e.preventDefault();

    new PDFDownload();
  });
});
